import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import * as React from 'react';

import { UitkDialog, UitkDialogContent } from 'uitk-react-dialog';
import { UitkHeading } from 'uitk-react-text';
import { LocalizedText, useLocalization } from '@shared-ui/localization-context';

export interface FlexDocumentDialogProps {
  url: string;
  headerName: string;
}

export const FlexDocumentDialog: React.FunctionComponent<FlexDocumentDialogProps> = ({ url, headerName }) => {
  const l10n = useLocalization();

  const noAction = () => {
    return;
  };

  return (
    <DialogRoute id="flex-document-dialog">
      <Layer id="dialog">
        <UitkDialog className="FlexDocument__dialog">
          <UitkDialogContent key="flexDialogContent1" className="FlexDocumentContent__dialog">
            <UitkHeading tag="h2" size={3}>
              <LocalizedText message={headerName} />
            </UitkHeading>
            <iframe src={url} />
          </UitkDialogContent>
        </UitkDialog>
      </Layer>
    </DialogRoute>
  );
};
